module.exports = __webpack_public_path__ + "media/images/iconTrendUp__inactive--dark-98ec98e994982d86b3bcb56bc944470b.png";